import _o2sService from './_o2sServices';
import { IFilter } from '../models/filters/filter';

import { ILotFilter } from '../models/filters/lotFilter';
import { API_CENTRE } from './config';
import { ILotForm } from '../models/forms/lotForm';
import { ILotPDTO } from '../models/dtos/lotPDTO';
import DispatchManufactoringServices from './DispatchManufactoringService';
import { ServiceOperationResult } from '../models/api/serviceOperationResult';
import { IEjaculateCompositeResponse } from '../models/api/ejaculateCompositeApiResponse';
import { apiCallWithAuth } from '../helper/apiManager';

export default class LotServices extends _o2sService {
    protected static override mainUrl:string = API_CENTRE + '/api/v1/Lot';
    protected static override getUrlFilter<F extends ILotFilter>(filter?: F): string {;
        let url = super.getUrlFilter(filter as IFilter);
        if (filter != null)
        {
            if (filter.lotNumber != null)
                url += '&LotNumber=' + filter.lotNumber;
            if (filter.isHeterospermie != null)
                url += '&IsHeterospermie=' + filter.isHeterospermie;
            if (filter.centerId != null)
                url += '&CenterId=' + filter.centerId;
            if (filter.geneticTypeId != null)
                url += '&GeneticTypeId=' + filter.geneticTypeId;
            if (filter.productionId != null)
                url += '&ProductionId=' + filter.productionId;
            if (filter.dateFrom != null)
                url += '&DateFrom=' + filter.dateFrom.toISOString();
            // int[] côté back : une occurrence par valeur, comme StockMovementService.
            if (filter.ids != null && filter.ids.length > 0)
                filter.ids.forEach(id => url += '&Ids=' + id);
            if (filter.includeProducerCenter != null)
                url += '&IncludeProducerCenter=' + filter.includeProducerCenter;
        }
        return url;
    }

    protected static override toDTO(obj: ILotForm): ILotPDTO {
        const dto = super.toDTO(obj) as ILotPDTO;
        dto.belongsToLots = obj.belongsToLots?.map(l => DispatchManufactoringServices.toDTO(l)) || [];
        dto.partOfLots = obj.partOfLots?.map(l => DispatchManufactoringServices.toDTO(l)) || [];
        return dto;
    }

    /**
     * Appel composite : retourne lots + production + dispatches + analyses en une seule requête
     */
    /**
     * @param dateFrom Borne basse optionnelle sur la date de lot. Omise = aucune borne, et c'est
     *   le cas nominal de l'écran « Prélèvements en attente » : il n'affiche aucune notion de
     *   période, il doit donc tout montrer. Le paramètre reste pour un usage borné éventuel.
     */
    static async getEjaculateData(centerId: number, dateFrom?: Date, minVolume?: number): Promise<ServiceOperationResult<IEjaculateCompositeResponse[]>> {
        try {
            let url = `${this.mainUrl}/ejaculate?centerId=${centerId}`;
            if (dateFrom != null) url += `&dateFrom=${dateFrom.toISOString()}`;
            if (minVolume != null) url += `&minVolume=${minVolume}`;
            const result = await apiCallWithAuth(url, 'get');
            return new ServiceOperationResult<IEjaculateCompositeResponse[]>(false, result.data);
        } catch (e) {
            return new ServiceOperationResult<IEjaculateCompositeResponse[]>(true, []);
        }
    }
}
